<template>
	<div class="ct-header">
		<div class="ct-header-taille ct-resolution-width">
			<div id="ct-header-logo">
				<img src="../assets/logo.svg" class="ct-header-logo-img"/>
			</div>

			<div id="ct-header-menu">
				<router-link class="ct-header-menu-item ct-clickable" to="/entreprise">
					<div class="ct-header-menu-item-block">
						<i class="material-icons ct-header-menu-icone"
						   :class="{'ct-header-selected-line': isCurrentPath('/entreprise')}">home</i>
						<span>{{ entreprise }}</span>
					</div>
				</router-link>

				<router-link class="ct-header-menu-item ct-clickable" to="/realisations">
					<div class="ct-header-menu-item-block">
						<i class="material-icons ct-header-menu-icone"
						   :class="{'ct-header-selected-line': isCurrentPath('/realisations')}">extension</i>
						<span>{{ realisations }}</span>
					</div>
				</router-link>

				<router-link class="ct-header-menu-item ct-clickable" to="/contact">
					<div class="ct-header-menu-item-block">
						<i class="material-icons ct-header-menu-icone"
						   :class="{'ct-header-selected-line': isCurrentPath('/contact')}">email</i>
						<span>{{ contact }}</span>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CtHeader',
		data() {
			return {
				entreprise: 'Entreprise',
				realisations: 'Réalisations',
				contact: 'Contact'
			}
		},
		methods: {
			isCurrentPath(to) {
				return this.$route.path.match(new RegExp("^"+to));
			}
		}
	}
</script>

<style scoped>
	.ct-header {
		display: flex;
		justify-content: center;
		background-color: #FAFAFA;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

	.ct-header-taille {
		display: flex;
		justify-content: space-between;
	}

	#ct-header-logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 20px;
	}

	.ct-header-logo-img {
		height: 40px;
	}

	#ct-header-menu {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		font-family: 'EnterTheGrid';
		font-size: 1.2em;
	}

	.ct-header-menu-item {
		padding: 20px;
		transition: background-color .3s;
		-webkit-transition: background-color .3s;
	}

	.ct-header-menu-item:hover {
		background-color: #efefef;
	}

	.ct-header-menu-item-block {
		display: flex;
		/* align-items: flex-end; */
        align-items: end;
	}

	.ct-header-selected-line {
		color: #B0E900;
	}

	.ct-header-menu-icone {
		padding-right: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/CtHeader.vue